export default "__VITE_ASSET__DlgdEmSo__"